import { cn } from "../../lib/cn";

export function SectionTitle({ children, className }:{
  children: React.ReactNode; className?: string;
}) {
  return (
    <div className="text-center mb-4 md:mb-16">
      <h2 className={cn("text-2xl md:text-3xl font-light text-black mb-6", className)}>
        {children}
      </h2>
    </div>
  );
}

export function Subheading({ children, className }:{
  children: React.ReactNode; className?: string;
}) {
  return (
    <h2 className={cn("font-medium text-black mb-2 text-lg md:text-2xl", className)}>
      {children}
    </h2>
  );
}